export default () => ({
  // MODULE LABELS
  moduleLabelsCategories: [],
  moduleLabelsCategoriesLoading: false,
});
